let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("60Nbf")).then(() => parcelRequire('lNp1U'));